<template lang="pug">
v-container(fluid ma-0)
  v-row(class=" theme-e-footer-container tw-text-white tw-h-64")
    v-col(class="fill-height ")
      v-row(class="fill-height")
        v-col(cols="3" class="pa-0 fill-height")
          v-row(no-gutters align="center" class="fill-height")
            v-col(cols="auto" class="fill-height")
              div(class="tw-w-24 tw-h-24 tw-mx-3 tw-border-4 tw-rounded tw-mt-4 tw-overflow-hidden tw-border-white ")
                v-img(
                  v-if="website.logo"
                  :src="path(website.logo)"
                  cover
                  height="100%"
                  width="100%"
                )
                v-img(
                  v-else
                  src="@/components/kubiqa/website/themes/theme-e/images/logo.png"
                  cover
                  height="100%"
                  width="100%"
                )
            v-col(cols="" class="pa-0 fill-height pt-4")
              kubiqa-website-shared-widget-editor(
                page="home"
                placement="footer_left"
                @content="(content) => (content != null ? ((defaultFooterLeft = false), key++) : ((defaultFooterLeft = true), key++))"
              )
              div(v-if="defaultFooterLeft" :key="key")
                div
                  span(class=" tw-text-blueGray-lighten-3 tw-text-lg tw-font-bold") {{ this.$faker().company.companyName() }}
                div(class="tw-pt-3")
                  span(class=" tw-text-blueGray-lighten-3 tw-font-medium") {{ this.$faker().address.streetAddress((useFullAddress = true)) }}

        v-col(class="tw-h-full pa-0")
          v-row(no-gutters align="start" class="tw-w-full tw-h-full")
            v-col(align="start" class="tw-h-full tw-w-full  ")
              kubiqa-website-shared-widget-editor(
                page="home"
                placement="footer_center"
                @content="(content) => (content != null ? ((defaultFooterCenter = false), key++) : ((defaultFooterCenter = true), key++))"
                class="pt-4"
              )
          div(v-if="defaultFooterCenter" :key="key")
            v-row
              v-col
                span(class="tw-text-white tw-text-lg tw-font-medium") Properties
            v-row
              v-col(class="tw-text-blueGray-lighten-3 tw-font-medium")
                div(class="tw-py-1") Appartments
                div(class="tw-py-1") Houses
                div(class="tw-py-1") Commercial
                div(class="tw-py-1") Plots
            v-col(cols="2")
              v-row
                v-col
                  span(class="tw-text-white tw-text-lg tw-font-medium") Opportunities
              v-row
                v-col(class="tw-text-blueGray-lighten-3 tw-font-medium")
                  div(class="tw-py-1") Rent
                  div(class="tw-py-1") Buy
                  div(class="tw-py-1") Sell

        v-col(cols="3" class="fill-height pa-0")
          v-row(no-gutters class="pt-4 pr-2 fill-height")
            kubiqa-website-shared-widget-editor(
              page="home"
              placement="footer_right"
              @content="(content) => (content != null ? ((defaultFooterRight = false), key++) : ((defaultFooterRight = true), key++))"
            )
          div(v-if="defaultFooterRight" :key="key")
            v-row
              v-col
                span(class="tw-text-white tw-text-lg tw-font-medium") Contact Us
            v-row
              v-col(class="tw-text-blueGray-lighten-3 tw-font-medium")
                div(class="tw-py-1")
                  v-icon(small color="blue-grey lighten-3") mdi-phone-classic
                  span(class="tw-ml-2 tw-mt-2") {{ this.$faker().phone.phoneNumber() }}
                div(class="tw-py-1") 
                div(class="tw-py-1")
                  v-icon(color="blue-grey lighten-3") mdi-facebook
                  v-icon(color="blue-grey lighten-3" class="tw-mx-2") mdi-twitter
                  v-icon(color="blue-grey lighten-3") mdi-whatsapp
  v-row(justify="end" class="theme-e-footer-container tw-border-t tw-border-blueGray-darken-3")
    v-col(cols="auto")
      span(class=" tw-font-medium tw-text-sm tw-text-blueGray-lighten-1") Powered by Kubiqa
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    website() {
      return this.$store.getters['website/website'];
    },
  },
  methods: {},
};
</script>
<style lang="scss">
.theme-e-footer-container {
  background-color: #10151f;
  color: white;
}
</style>
